


















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { audio } from "@/config/host.config";
import PosterEditor from "@/components/app/images/poster-editor.vue";
import StandartModal from "@/components/app/standart-modal.vue";

const tracksUrl = audio.songs.replace("/songs", "/id3/tracks");

interface ITrackMetadata {
  title?: string;
  artist?: string;
  album?: string;
  duration?: number;
}

interface ITrack {
  _id: string;
  name: string;
  generatedName?: string;
  path?: string;
  metadata?: ITrackMetadata;
  src?: { cover?: string };
}

@Component({
  components: { StandartModal, PosterEditor },
})
class TrackEditModal extends Vue {
  @Prop({ type: Object, default: null }) track!: ITrack | null;

  cover = "";
  saving = false;

  @Watch("track", { immediate: true })
  onTrackChange(track: ITrack | null): void {
    this.cover = track?.src?.cover || "";
  }

  trackTitle(track: ITrack): string {
    return (track.metadata && track.metadata.title) || track.name || "—";
  }

  onCoverUpdate(filename: string): void {
    this.cover = filename;
  }

  async save(): Promise<void> {
    if (!this.track?._id) return;
    this.saving = true;
    try {
      const res = await this.$axios.put(`${tracksUrl}/${this.track._id}`, {
        src: { cover: this.cover },
      });
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit("saved", this.track._id);
        this.$bvModal.hide("track-edit-modal");
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.saving = false;
    }
  }

  onHide(): void {
    this.$emit("hide");
  }
}
export default TrackEditModal;
